<template>
  <!-- TODO move to common -->
  <!--
  {
    "id": "nL8N2E31MN",
    "title": "Umweltschützer kaufen RWE Ökokurs nicht ab",
    "datePublished": "2020-06-26T11:21:00.00Z",
    "teaserThumbnailUrl": "http://api.rkd.reuters.com/api/topnews/topnews-images/2020-02-02T091205Z_867208809_RC29SE9QREPW_RTRMADP_2_GERMANY-ENERGY-COAL.JPG.ashx",
    "teaserText": "Die Gegner der Kohleverstromung in Deutschland lassen auch nach dem beschlossenen Kohleausstieg nicht locker.",
    "commentsCount": null,
    "category": {
      "id": "Finanzen"
    },
    "source": {
      "id": "REFINITIV"
    }
  }
  -->

  <v-container class="fin-news-list">
    <v-row v-if="featuredItems">
      <v-col cols="12"
             v-for="(featuredItem, featuredItemIndex) in featuredItems" :key="featuredItemIndex">
        <fin-featured-news-item :value="featuredItem"/>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <fin-news-items v-if="items"
                        :displayModeCarousel="false"
                        :hide-image="false"
                        :largeCard="true"
                        :show-item-background="false"
                        :show-item-teaser="showItemTeaser"
                        :show-item-title="true"
                        :value="items"
                        @loadMoreNews="$emit('loadMoreNews')"/>
        <p v-if="items.length === 0 && !featuredItems">Keine Daten verfügbar</p>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import FinNewsItems from '../../../common/news/NewsItems'
import FinFeaturedNewsItem from "@/components/common/news/FeaturedNewsItem"

export default {
  name: 'FinNewsList',
  components: {
    FinFeaturedNewsItem,
    FinNewsItems
  },
  props: {
    items: {
      type: Array
    },
    featuredItems: {
      type: Array
    },
    /** set to true to display the teaser */
    showItemTeaser: {
      typ: Boolean,
      default: true
    },
  }
}
</script>

<style lang="scss" scoped>
a {
  color: $fin-color-primary-dark;
  text-decoration: none !important;
}
</style>
